import React from "react";
import "../css/loadingUser.scss";
import { hesLogo } from "../images/hesLogo";

const LoadingUser = () => {
  return (
    <div className="loadingUser">
      <div className="logoContainer">
        <img src={hesLogo} alt="Henderson Electrical Services Logo" />
        <div className="segmentContainer">
          <span className={`${"segment"} ${"seg1"}`}></span>
          <span className={`${"segment"} ${"seg2"}`}></span>
          <span className={`${"segment"} ${"seg3"}`}></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingUser;
